<style scoped lang="less">
.chart{
  width: 100%;
  height: 3.7rem;
}
</style>
<script>
import methods from './methods.js'

export default {
  name: "chart",
  mixins: [methods]
}
</script>
<template>
  <div class="chart">
    <none-data :height="3.5" v-if="isEmpty"></none-data>
    <div class="chart" v-show="!isEmpty" ref="chart"/>
  </div>
</template>

